import { Address } from "../types/address";
import { UserEntity } from "./index";
export type BeneficialBaseEntity = {
	id?: number;
	name?: string;
	gender?: 'M' | 'F';
	firstName?: string;
	description?: string;
	lastName?: string;
	fullName?: string;
	signature?: string;
	nationality?: 'AFG' | 'ALA' | 'ALB' | 'DZA' | 'ASM' | 'AND' | 'AGO' | 'AIA' | 'ATA' | 'ATG' | 'ARG' | 'ARM' | 'ABW' | 'AUS' | 'AUT' | 'AZE' | 'BHS' | 'BHR' | 'BGD' | 'BRB' | 'BLR' | 'BEL' | 'BLZ' | 'BEN' | 'BMU' | 'BTN' | 'BOL' | 'BES' | 'BIH' | 'BWA' | 'BVT' | 'BRA' | 'IOT' | 'BRN' | 'BGR' | 'BFA' | 'BDI' | 'CPV' | 'KHM' | 'CMR' | 'CAN' | 'CYM' | 'CAF' | 'TCD' | 'CHL' | 'CHN' | 'CXR' | 'CCK' | 'COL' | 'COM' | 'COD' | 'COG' | 'COK' | 'CRI' | 'CIV' | 'HRV' | 'CUB' | 'CUW' | 'CYP' | 'CZE' | 'DNK' | 'DJI' | 'DMA' | 'DOM' | 'ECU' | 'EGY' | 'SLV' | 'GNQ' | 'ERI' | 'EST' | 'SWZ' | 'ETH' | 'FLK' | 'FRO' | 'FJI' | 'FIN' | 'FRA' | 'GUF' | 'PYF' | 'ATF' | 'GAB' | 'GMB' | 'GEO' | 'DEU' | 'GHA' | 'GIB' | 'GRC' | 'GRL' | 'GRD' | 'GLP' | 'GUM' | 'GTM' | 'GGY' | 'GIN' | 'GNB' | 'GUY' | 'HTI' | 'HMD' | 'VAT' | 'HND' | 'HKG' | 'HUN' | 'ISL' | 'IND' | 'IDN' | 'IRN' | 'IRQ' | 'IRL' | 'IMN' | 'ISR' | 'ITA' | 'JAM' | 'JPN' | 'JEY' | 'JOR' | 'KAZ' | 'KEN' | 'KIR' | 'PRK' | 'KOR' | 'KWT' | 'KGZ' | 'LAO' | 'LVA' | 'LBN' | 'LSO' | 'LBR' | 'LBY' | 'LIE' | 'LTU' | 'LUX' | 'MAC' | 'MDG' | 'MWI' | 'MYS' | 'MDV' | 'MLI' | 'MLT' | 'MHL' | 'MTQ' | 'MRT' | 'MUS' | 'MYT' | 'MEX' | 'FSM' | 'MDA' | 'MCO' | 'MNG' | 'MNE' | 'MSR' | 'MAR' | 'MOZ' | 'MMR' | 'NAM' | 'NRU' | 'NPL' | 'NLD' | 'NCL' | 'NZL' | 'NIC' | 'NER' | 'NGA' | 'NIU' | 'NFK' | 'MKD' | 'MNP' | 'NOR' | 'OMN' | 'PAK' | 'PLW' | 'PSE' | 'PAN' | 'PNG' | 'PRY' | 'PER' | 'PHL' | 'PCN' | 'POL' | 'PRT' | 'PRI' | 'QAT' | 'REU' | 'ROU' | 'RUS' | 'RWA' | 'BLM' | 'SHN' | 'KNA' | 'LCA' | 'MAF' | 'SPM' | 'VCT' | 'WSM' | 'SMR' | 'STP' | 'SAU' | 'SEN' | 'SRB' | 'SYC' | 'SLE' | 'SGP' | 'SXM' | 'SVK' | 'SVN' | 'SLB' | 'SOM' | 'ZAF' | 'SGS' | 'SSD' | 'ESP' | 'LKA' | 'SDN' | 'SUR' | 'SJM' | 'SWE' | 'CHE' | 'SYR' | 'TWN' | 'TJK' | 'TZA' | 'THA' | 'TLS' | 'TGO' | 'TKL' | 'TON' | 'TTO' | 'TUN' | 'TUR' | 'TKM' | 'TCA' | 'TUV' | 'UGA' | 'UKR' | 'ARE' | 'GBR' | 'UMI' | 'USA' | 'URY' | 'UZB' | 'VUT' | 'VEN' | 'VNM' | 'VGB' | 'VIR' | 'WLF' | 'ESH' | 'YEM' | 'ZMB' | 'ZWE';
	dateOfBirth?: Date;
	placeOfBirth?: string;
	maritalStatus?: 'Single' | 'Married' | 'Divorced' | 'Widowed' | 'Separated' | 'Other';
	cin?: string;
	cinDeliveryDate?: Date;
	cinDeliverPlace?: string;
	jobTitle?: string;
	email?: string;
	profilePhoto?: { key: string, url: string };
	address?: Address;
	addressString?: string;
	createdAt?: Date;
	updatedAt?: Date;
	clientId?: UserEntity['id'];
	// client?: UserEntity;
};
export type BeneficialPersonEntity = BeneficialBaseEntity & {
	/**
 * unique fields:
 * -cin
 */
	type?: 'Person';
	passport?: string;
	hasAttorney?: boolean;
	attorney?: {
		gender?: 'M' | 'F';
		firstName?: string;
		lastName?: string;
		fullName?: string;
		cin?: string;
		cinDeliveryDate?: Date;
		cinDeliverPlace?: string;
		regionalFinancialOffice?: string;
		powerOfAttorneyDate?: Date;
		powerOfAttorneyReceitNumber?: string;
		powerOfAttorneyRegistrationNumber?: string;
	} | null;
	hasSpouse?: boolean;
	spouse?: {
		gender?: 'M' | 'F';
		firstName?: string;
		lastName?: string;
		fullName?: string;
		cin?: string;
		cinDeliveryDate?: Date;
		cinDeliverPlace?: string;
	} | null;
	hasSpouseAttorney?: boolean;
	spouseAttorney?: {
		gender?: 'M' | 'F';
		firstName?: string;
		lastName?: string;
		fullName?: string;
		cin?: string;
		cinDeliveryDate?: Date;
		cinDeliverPlace?: string;
		regionalFinancialOffice?: string;
		powerOfAttorneyDate?: Date;
		powerOfAttorneyReceitNumber?: string;
		powerOfAttorneyRegistrationNumber?: string;
	} | null;
};
export type BeneficialCompanyEntity = BeneficialBaseEntity & {
	/**
* unique fields:
* -registrationNumber
*/
	type?: 'Company';
	companyName?: string;
	socialCapital?: number;
	socialCapitalCurrency?: 'TND' | 'USD' | 'EUR' | 'GBP' | 'JPY' | 'AUD' | 'CAD' | 'CHF' | 'CNY' | 'SEK' | 'NZD' | 'MXN' | 'SGD' | 'HKD' | 'NOK' | 'KRW' | 'TRY' | 'RUB' | 'INR' | 'BRL' | 'ZAR' | 'DKK' | 'MYR' | 'THB' | 'PLN';
	postalAddress?: string;
	legalForm?: string;
	registrationNumber?: string;
	specialization?: string;
	hasAttorney?: boolean;
	attorney?: {
		gender?: 'M' | 'F';
		firstName?: string;
		lastName?: string;
		fullName?: string;
		cin?: string;
		cinDeliveryDate?: Date;
		cinDeliverPlace?: string;
		regionalFinancialOffice?: string;
		powerOfAttorneyDate?: Date;
		powerOfAttorneyReceitNumber?: string;
		powerOfAttorneyRegistrationNumber?: string;
	} | null;
};
export type BeneficialMinorEntity = BeneficialBaseEntity & {
	/**
* unique fields:
* -minorOrderNumber
*/
	type?: 'Minor';
	minorFirstName?: string;
	minorLastName?: string;
	minorFullName?: string;
	minorDateOfBirth?: Date;
	minorPlaceOfBirth?: string;
	minorNationality?: 'AFG' | 'ALA' | 'ALB' | 'DZA' | 'ASM' | 'AND' | 'AGO' | 'AIA' | 'ATA' | 'ATG' | 'ARG' | 'ARM' | 'ABW' | 'AUS' | 'AUT' | 'AZE' | 'BHS' | 'BHR' | 'BGD' | 'BRB' | 'BLR' | 'BEL' | 'BLZ' | 'BEN' | 'BMU' | 'BTN' | 'BOL' | 'BES' | 'BIH' | 'BWA' | 'BVT' | 'BRA' | 'IOT' | 'BRN' | 'BGR' | 'BFA' | 'BDI' | 'CPV' | 'KHM' | 'CMR' | 'CAN' | 'CYM' | 'CAF' | 'TCD' | 'CHL' | 'CHN' | 'CXR' | 'CCK' | 'COL' | 'COM' | 'COD' | 'COG' | 'COK' | 'CRI' | 'CIV' | 'HRV' | 'CUB' | 'CUW' | 'CYP' | 'CZE' | 'DNK' | 'DJI' | 'DMA' | 'DOM' | 'ECU' | 'EGY' | 'SLV' | 'GNQ' | 'ERI' | 'EST' | 'SWZ' | 'ETH' | 'FLK' | 'FRO' | 'FJI' | 'FIN' | 'FRA' | 'GUF' | 'PYF' | 'ATF' | 'GAB' | 'GMB' | 'GEO' | 'DEU' | 'GHA' | 'GIB' | 'GRC' | 'GRL' | 'GRD' | 'GLP' | 'GUM' | 'GTM' | 'GGY' | 'GIN' | 'GNB' | 'GUY' | 'HTI' | 'HMD' | 'VAT' | 'HND' | 'HKG' | 'HUN' | 'ISL' | 'IND' | 'IRN' | 'IRQ' | 'IRL' | 'IMN' | 'ISR' | 'ITA' | 'JAM' | 'JPN' | 'JEY' | 'JOR' | 'KAZ' | 'KEN' | 'KIR' | 'PRK' | 'KOR' | 'KWT' | 'KGZ' | 'LAO' | 'LVA' | 'LBN' | 'LSO' | 'LBR' | 'LBY' | 'LIE' | 'LTU' | 'LUX' | 'MAC' | 'MDG' | 'MWI' | 'MYS' | 'MDV' | 'MLI' | 'MLT' | 'MHL' | 'MTQ' | 'MRT' | 'MUS' | 'MYT' | 'MEX' | 'FSM' | 'MDA' | 'MCO' | 'MNG' | 'MNE' | 'MSR' | 'MAR' | 'MOZ' | 'MMR' | 'NAM' | 'NRU' | 'NPL' | 'NLD' | 'NCL' | 'NZL' | 'NIC' | 'NER' | 'NGA' | 'NIU' | 'NFK' | 'MKD' | 'MNP' | 'NOR' | 'OMN' | 'PAK' | 'PLW' | 'PSE' | 'PAN' | 'PNG' | 'PRY' | 'PER' | 'PHL' | 'PCN' | 'POL' | 'PRT' | 'PRI' | 'QAT' | 'REU' | 'ROU' | 'RUS' | 'RWA' | 'BLM' | 'SHN' | 'KNA' | 'LCA' | 'MAF' | 'SPM' | 'VCT' | 'WSM' | 'SMR' | 'STP' | 'SAU' | 'SEN' | 'SRB' | 'SYC' | 'SLE' | 'SGP' | 'SXM' | 'SVK' | 'SVN' | 'SLB' | 'SOM' | 'ZAF' | 'SGS' | 'SSD' | 'ESP' | 'LKA' | 'SDN' | 'SUR' | 'SJM' | 'SWE' | 'CHE' | 'SYR' | 'TWN' | 'TJK' | 'TZA' | 'THA' | 'TLS' | 'TGO' | 'TKL' | 'TON' | 'TTO' | 'TUN' | 'TUR' | 'TKM' | 'TCA' | 'TUV' | 'UGA' | 'UKR' | 'ARE' | 'GBR' | 'UMI' | 'USA' | 'URY' | 'UZB' | 'VUT' | 'VEN' | 'VNM' | 'VGB' | 'VIR' | 'WLF' | 'ESH' | 'YEM' | 'ZMB' | 'ZWE';
	minorGender?: 'M' | 'F';
	minorOrderNumber?: string;
	minorOrderDate?: Date;
	minorOrderName?: string;
	minorOrderCourt?: string;
	hasAttorney?: boolean;
	attorney?: {
		gender?: 'M' | 'F';
		firstName?: string;
		lastName?: string;
		fullName?: string;
		cin?: string;
		cinDeliveryDate?: Date;
		cinDeliverPlace?: string;
		regionalFinancialOffice?: string;
		powerOfAttorneyDate?: Date;
		powerOfAttorneyReceitNumber?: string;
		powerOfAttorneyRegistrationNumber?: string;
	} | null;
};

export type BeneficialEntity = BeneficialPersonEntity
	| BeneficialCompanyEntity
	| BeneficialMinorEntity
	;

export const beneficialTypes: BeneficialEntity['type'][] = ['Person', 'Company', 'Minor']